import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CollapsibleArrowComponent} from './collapsible-arrow/collapsible-arrow.component';

@Component({
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss']
})
export class CollapsibleComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() public opened = false;
  @Input() public arrowElementRef: CollapsibleArrowComponent
  @Output() public open = new EventEmitter<void>();
  @Output() public close = new EventEmitter<void>();

  public _opened;

  public ngOnInit(): void {
    this._opened = this.opened
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('opened') && changes['opened'] != null) {
      if (changes['opened'].isFirstChange() && this.arrowElementRef != null) {
        this.arrowElementRef.opened = this.opened;
      }
      this.toggle(changes['opened'].currentValue);
    }
  }

  public ngAfterViewInit(): void {
    this.arrowElementRef?.toggle.subscribe(_ => {
      const newState = !this._opened;
      this.arrowElementRef.opened = newState;
      this.toggle(newState);
    });
  }

  public toggle(state: boolean) {
    if (state !== this._opened) {
      if (state) {
        this._open();
      } else {
        this._close();
      }
    }
  }

  private _close() {
    this._opened = false;
    this.close.emit();
  }

  private _open() {
    this._opened = true;
    this.open.emit();
  }
}
